import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { AgentInfo } from 'src/app/front-user/services/e-booking/shared/models/agent.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { RegistrationAdminDto } from '../../shared/models/registration-admin.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { ResponseObject } from 'src/app/shared/models/response-object.model';

@Component({
  selector: 'app-activate-agent-with-deactivation-date',
  templateUrl: './activate-agent-with-deactivation-date.component.html',
  styleUrls: ['./activate-agent-with-deactivation-date.component.css']
})
export class ActivateAgentWithDeactivationDateComponent implements OnInit {
  activateAgent: FormGroup;
  agentId: string;
  showRequest = false;
  user: User = new User();
  adminDecisionObject: RegistrationAdminDto = new RegistrationAdminDto();
  public getAgentInfo: AgentInfo = new AgentInfo();
  formSubmitted: boolean = false;
  todayDate= new Date(new Date().setDate(new Date().getDate() + 1));
  isErrorMessage: boolean= false;
  constructor(private formBuilder: FormBuilder, private globalSrv: GlobalServices,
    private alertService: AlertService,
    private adminSrv: RegistrationAdminService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService, private router: Router,
    private agentSrv: AgentService) {
    if (history.state.data ) {
      this.agentId = history.state.data;
    }else{
        window.history.back();
    }

    this.user = this.authenticationService.currentUserValue;;
  }

  ngOnInit() {
      this.buildForm();
  }

  buildForm() {
    this.activateAgent = this.formBuilder.group({
      DeactivtationDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
    });
  }

  get f() {
    return this.activateAgent.controls;
  }

  onSubmit() {
    this.formSubmitted = true;
    // stop here if form is invalid
    if (this.activateAgent.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;

    this.adminDecisionObject = this.activateAgent.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.AgentId = this.agentId;


    this.adminSrv.ActivateAgentDueCertificate(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.activateAgent.reset();
            this.showRequest = true;
            this.isErrorMessage= false;
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage= true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
          }

        });
  }
}
